import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { editData, getData } from "../../controllers/career.HeaderSection.controller";
import Button from "../../Components/Button";

const HeaderSection = () => {
    const [image, setImage] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [data, setData] = useState([]);

    const [formData, setFormData] = useState({
        title: "",
        subtitle: "",
        file: null,
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted: ", formData);
    };

    const handleRemoveImage = () => {
        setImage(null); // Reset the image state
        setFormData({ ...formData, file: null });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };



    const fetchData = async () => {
        try {
            const res = await getData({});
            console.log("res => ", res);

            if (res.status === 200) {
                const apiData = res?.data?.data;
                const tableData = apiData?.map((d) => ({
                    id: d.id,
                    title: d.title,
                    subtitle: d.subtitle,
                    image: d.image_url || "",
                }));
                setData(tableData);

                if (tableData.length > 0) {
                    const firstItem = tableData[0];
                    setSelectedRowId(firstItem.id);
                    setFormData({
                        title: firstItem.title,
                        subtitle: firstItem.subtitle,
                        file: null,
                    });
                    setImage(firstItem.image);
                }
            } else {
                toast.error("Failed to fetch data.");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Something went wrong while fetching data.");
        }
    };
    useEffect(() => {
        fetchData();
    }, []);



    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            setFormData({ ...formData, file });
        } else {
            setFormData({ ...formData, file: null });
        }
    };

    // const editBtn = async () => {
    //     try {
    //         const { title, subtitle, file } = formData;

    //         if (!title || !subtitle) {
    //             toast.error("Please fill in all the required fields.");
    //             return;
    //         }

    //         toast.loading("Submitting your data...");

    //         const res = await editData({
    //             id: selectedRowId,
    //             title,
    //             subtitle,
    //             file,
    //         });

    //         const message = res.data.message;
    //         toast.dismiss();

    //         if (res.status === 200) {
    //             toast.success(message);
    //             setFormData({
    //                 title: "",
    //                 subtitle: "",
    //                 file: null,
    //             });

    //             setImage(null);
    //             fetchData();
    //         } else {
    //             toast.error(message || "Failed to edit data.");
    //         }
    //     } catch (error) {
    //         toast.dismiss();
    //         console.error("Error editing data:", error);

    //         const message = error?.response?.data?.message || "Something went wrong!";
    //         toast.error(message);
    //     }
    // };
    const editBtn = async () => {
        try {
            const { title, subtitle, file } = formData;

            if (!title || !subtitle) {
                toast.error("Please fill in all the required fields.");
                return;
            }

            toast.loading("Submitting your data...");

            const res = await editData({
                id: selectedRowId,
                title,
                subtitle,
                file,
            });

            const message = res.data.message;
            toast.dismiss();


            if (res.status === 200) {
                toast.success(message);
                setFormData({
                    title: "",
                    sub_title: "",
                    file: null,
                });
                setImage(null);


                fetchData();
            } else {
                toast.error(message || "Failed to edit data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error editing data:", error);

            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };

    console.log('fm data => ', formData)

    return (
        <div>
            <div className="container">
                <div className="p-6 mx-auto bg-white rounded-lg shadow-md">
                    <form onSubmit={handleSubmit}>
                        <h1 className="text-xl font-bold text-gray-700 mb-4">Header Section</h1>
                        <div className="mb-4">
                            <div className="mb-6">
                                <div style={{ backgroundImage: `url(${image})` }} className="bg-cover bg-center mt-2 flex flex-col items-center justify-center border-dashed border-2 border-gray-300 rounded-lg w-[98] h-[430px]">

                                    <div className="text-gray-500">
                                        <div className="flex justify-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={1.5}
                                                stroke="currentColor"
                                                className="w-10 h-10"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M12 4.5v15m7.5-7.5h-15"
                                                />
                                            </svg>
                                        </div>
                                        <div className="p-4 text-center">
                                            <p className="text-lg text-gray-600 mb-4">Drag and drop image here</p>
                                            {/* <p className="text-gray-400 mb-4">or</p> */}
                                            <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
                                            <div className="flex space-x-4">
                                                {/* Remove Button */}
                                               {image && <button  onClick={handleRemoveImage} className="bg-red-100 text-red-500 font-medium px-6 py-2 border-2 border-red-500 rounded-lg hover:bg-red-500 hover:text-white transition-all">
                                                    Remove
                                                </button>}
                                                {/* Browse Image Button */}
                                                <label className="bg-purple-100 text-[#92288C] font-medium px-6 py-2 border-2 border-[#92288C] rounded-lg hover:bg-[#92288C] hover:text-white transition-all">
                                                    <input
                                                        type="file"
                                                        accept=".jpg, .png"
                                                        onChange={handleImageChange}
                                                        className="hidden"
                                                    />
                                                    Browse image
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-6">
                            <div className="mb-4 w-full text-left">
                                <label className="block text-gray-600 font-medium mb-1">
                                    Title
                                </label>
                                <input
                                    id="title"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#92288C]"
                                />
                            </div>
                            <div className="mb-4 w-full text-left">
                                <label className="block text-gray-600 font-medium mb-1">
                                    Subtitle
                                </label>
                                <input
                                    id="subtitle"
                                    name="subtitle"
                                    value={formData.subtitle}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#92288C]"
                                />
                            </div>
                        </div>
                        <div className="flex justify-end space-x-4">
                            <button
                                type="button"
                                onClick={() => {
                                    setFormData({
                                        title: "",
                                        subtitle: "",
                                        file: null,
                                    });
                                    setImage(null);
                                    setSelectedRowId(null);
                                }}
                                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={editBtn
                                }
                                //                                 onClick={() => {
                                //                                     setFormData({
                                //                                         title: formData.title,
                                //                                         sub_title: formData.sub_title,
                                //                                         file: formData.file,
                                //                                     });
                                //                                     setImage();                                     setSelectedRowId(null); 
                                // editBtn()
                                //                                 }}


                                className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175] justify-end"
                            >
                                Update
                            </button>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    );
};

export default HeaderSection;
